import type { PageData } from '@/gem.types';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faClock } from '@fortawesome/free-solid-svg-icons';

interface Props {
  profileImage?: string;
  name: string;
  host?: string;
  description?: string;
  duration?: string;
  profileBorderWidth?: number;
  profileBorderColor?: string;
  buttonText?: string;
  buttonAction?: () => void;
  theme: PageData['theme'];
}

const SchedulerHeader = ({
                           profileImage,
                           name,
                           host,
                           description,
                           duration,
                           profileBorderWidth = 4,
                           profileBorderColor = 'white',
                           buttonText,
                           buttonAction,
                           theme
                         }: Props) => {
  return (
    <motion.div
      className="border rounded-2xl flex flex-col items-center"
      style={{
        borderColor: theme?.borderColor || 'rgb(55, 65, 81)',
        backgroundColor: theme?.backgroundColor || 'rgb(243, 244, 246)'
      }}
    >
      <motion.div
        className="flex flex-col items-center p-5 text-left"
        style={{ color: theme?.textColor || 'rgb(31, 41, 55)' }}
      >
        {profileImage && (
          <motion.img
            src={profileImage}
            alt="Profile image"
            className="rounded-full w-20 h-20"
            style={{
              borderWidth: profileBorderWidth || 4,
              borderColor: profileBorderColor || 'white'
            }}
          />
        )}
        <div className="text-center">
          <motion.h1 className="text-2xl font-bold mb-1">{name}</motion.h1>
          <motion.div className="text-sm flex items-center justify-center mb-2">
            {host && (
              <div className="px-2">
                <FontAwesomeIcon icon={faUserCircle} />
                <span className="pl-2">{host}</span>
              </div>
            )}
            {duration && (
              <div className="px-2">
                <FontAwesomeIcon icon={faClock} />
                <span className="pl-2">{duration}</span>
              </div>
            )}
          </motion.div>

          {description && <motion.p className="text-base">{description}</motion.p>}
          {buttonText && buttonAction && (
            <motion.button
              onClick={buttonAction}
              type="button"
              className="rounded-lg text-sm px-4 py-2 mt-4 border"
              style={{
                color: theme?.buttonTextColor || 'rgb(31, 41, 55)',
                borderColor: theme?.borderColor || 'rgb(55, 65, 81)',
                backgroundColor: theme?.primaryColor || 'rgb(243, 244, 246)'
              }}
            >
              {buttonText}
            </motion.button>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SchedulerHeader;
